module.exports = __webpack_public_path__ + "static/media/data3.639d44fe.jpg";